import { Workbook } from '@progress/kendo-angular-excel-export';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Inject,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'; // ngx-bootstrap is confirmed available
import { saveAs } from '@progress/kendo-file-saver';
import * as XLSX from 'xlsx';

import { CommonService } from '../../../question/services/commonservice';
import { ManageServiceLineService } from '../../services/manage-service-line.service';
import {
  ServiceLineSurveyMap,
  ServiceLineServiceProviderMap,
  UserDetail,
  StatusDetail,
  DocumentDetail,
  MasterRespondents,
  Language,
  SurveyServiceLineLanguageMappedDetail
} from '../../models/manage-service-line.model';

@Component({
  selector: 'manageserviceline',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, AgGridAngular, IsgGridComponent, BsDatepickerModule],
  templateUrl: './manage-service-line.component.html',
  styleUrls: ['./manage-service-line.component.css'],
  providers: [CommonService, ManageServiceLineService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageServiceLineComponent extends BaseHttpReqRespService implements OnInit {

  // ── ViewChild modal refs ───────────────────────────────────────────────────
  @ViewChild('mapSurveyModal') mapSurveyModal!: TemplateRef<any>;
  @ViewChild('mapProviderModal') mapProviderModal!: TemplateRef<any>;
  @ViewChild('surveyScheduleModal') surveyScheduleModal!: TemplateRef<any>;
  @ViewChild('copySurveyModal') copySurveyModal!: TemplateRef<any>;
  @ViewChild('deleteSurveyModal') deleteSurveyModal!: TemplateRef<any>;
  @ViewChild('deleteProviderModal') deleteProviderModal!: TemplateRef<any>;
  @ViewChild('formatDownloadModal') formatDownloadModal!: TemplateRef<any>;
  @ViewChild('usersDownloadModal') usersDownloadModal!: TemplateRef<any>;
  @ViewChild('respondentModal') respondentModal!: TemplateRef<any>;
  @ViewChild('exceptionalUserModal') exceptionalUserModal!: TemplateRef<any>;
  @ViewChild('answersUploadModal') answersUploadModal!: TemplateRef<any>;
  @ViewChild('uploadDocumentModal') uploadDocumentModal!: TemplateRef<any>;
  @ViewChild('emailSettingModal') emailSettingModal!: TemplateRef<any>;
  @ViewChild('templateModal') templateModal!: TemplateRef<any>;
  @ViewChild('deleteLanguageMappingModal') deleteLanguageMappingModal!: TemplateRef<any>;
  @ViewChild('surveyProviderLanguageModal') surveyProviderLanguageModal!: TemplateRef<any>;

  modalRef: NgbModalRef | undefined;

  // ── Route params ───────────────────────────────────────────────────────────
  serviceLineId: string = '';
  serviceLineName: string = '';

  // ── Forms ──────────────────────────────────────────────────────────────────
  surveyForm!: FormGroup;
  serviceProviderForm!: FormGroup;
  copySurveyForm!: FormGroup;
  surveyScheduleForm!: FormGroup;
  respendentForm!: FormGroup;
  exceptionalUserForm!: FormGroup;
  exceptionalFormatForm!: FormGroup;
  usersDownloadForm!: FormGroup;
  isTemplateSurveyForm!: FormGroup;
  surveyProviderLanguageForm!: FormGroup;
  exceptionalAnswersUpload!: FormGroup;
  uploadSurveyForm!: FormGroup;
  emailConfigurationForm!: FormGroup;

  // ── Grid data ──────────────────────────────────────────────────────────────
  serviceLineSurveyMapList: ServiceLineSurveyMap[] = [];
  serviceLineSurveyUnMapList: ServiceLineSurveyMap[] = [];
  serviceLineServiceProviderMapList: ServiceLineServiceProviderMap[] = [];
  serviceLineServiceProviderUnMapList: ServiceLineServiceProviderMap[] = [];
  companyUserList: UserDetail[] = [];
  statusList: StatusDetail[] = [];
  documentList: DocumentDetail[] = [];
  languageList: Language[] = [];
  surveyServiceLineLanguageMappedList: SurveyServiceLineLanguageMappedDetail[] = [];
  respondentsTypesList: MasterRespondents | null = null;

  // ── State ──────────────────────────────────────────────────────────────────
  successOrFailureMessage: string = '';
  isConsip: boolean = false;
  isProviderSurveyChecked: boolean = false;
  isTemplateSurveyChecked: boolean = false;
  companyIds: number[] = [];
  mapSurvey: string[] = [];
  unMapSurvey: string[] = [];
  mapServiceProvider: string[] = [];
  unMapServiceProvider: string[] = [];
  dateRangePickerModel: Date[] = [];
  currentSelectedSurveyName: string = '';
  currentCompanyName: string = '';
  currentFormatCompanyName: string = '';
  currentUploadCompanyName: string = '';
  currentServiceLineId: number = -1;
  currentCompanyId: number = -1;
  currentSurveyId: number = -1;
  currentFormatServiceLineId: number = -1;
  currentFormatCompanyId: number = -1;
  currentFormatSurveyId: number = -1;
  currentUserDownLoadSurveyId: number = -1;
  currentUploadServiceLineId: number = -1;
  currentUploadCompanyId: number = -1;
  currentUploadSurveyId: number = -1;
  currentUploadUserId: number = -1;
  currentUploadStatusId: number = -1;
  providerSurveyId: number = -1;
  clientSurveyId: number = -1;
  tempRespondentId: number = -1;
  tempServiceLineId: string = '';
  tempCompanyId: string = '';
  surveyId: string = '';
  file: File | null = null;
  fileName: string = '';
  arrayBuffer: any;
  isFileInvalid: boolean = false;
  deleteMappingId: string = '';
  delSurveyId: string = '';
  surveyDeleteId: number = 0;
  serviceLineDeleteId: number = 0;
  companyDeleteId: number = 0;
  selectedFiles: FileList | null = null;

  // ── Grid configs ───────────────────────────────────────────────────────────
  gridConfig: Partial<IsgGridConfig> = { height: '300px', pagination: true, pageSize: 10, autoSizeColumns: true };
  defaultColDef: ColDef = { sortable: true, filter: true, resizable: true };

  mappedSurveyColumns: ColDef[] = [
    { field: 'surveyId', hide: true },
    { headerName: 'Action', field: 'surveyId', width: 250, cellRenderer: (p: any) => this.actionRenderer(p), resizable: true },
    { field: 'serviceLineId', hide: true },
    { headerName: 'Survey', field: 'surveyName', width: 300, resizable: true },
    { headerName: 'Start Date', field: 'startDate', width: 120, resizable: true },
    { headerName: 'End Date', field: 'endDate', width: 120, resizable: true },
    { field: 'scheduleId', hide: true },
    { headerName: 'Show/Hide', width: 130, field: 'isShow', cellRenderer: (p: any) => this.showCheckBoxRenderer(p), resizable: true }
  ];

  unMappedSurveyColumns: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 50, checkboxSelection: true, headerCheckboxSelection: true },
    { field: 'surveyId', hide: true },
    { headerName: 'Survey Name', field: 'surveyName', width: 400, resizable: true }
  ];

  mappedServiceProviderColumns: ColDef[] = [
    { field: 'companyId', hide: true },
    { field: 'serviceLineId', hide: true },
    { headerName: 'Provider Name', field: 'companyName', width: 320, cellRenderer: (p: any) => this.getRespondents(p), resizable: true },
    { headerName: 'Users', width: 200, cellRenderer: (p: any) => this.companyLinkRenderer(p), resizable: true },
    { headerName: 'Delete', cellRenderer: (p: any) => this.deleteServiceProviderCellRenderer(p), resizable: true },
    { headerName: 'Format', width: 250, cellRenderer: (p: any) => this.formatDownload(p), resizable: true },
    { headerName: 'Upload', width: 250, cellRenderer: (p: any) => this.uploadAnswers(p), resizable: true }
  ];

  unMappedServiceProviderColumns: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 50, checkboxSelection: true, headerCheckboxSelection: true },
    { field: 'companyId', hide: true },
    { headerName: 'Service Provider Name', field: 'companyName', width: 440, resizable: true }
  ];

  companyUserColumnDefs: ColDef[] = [
    { field: 'userId', hide: true },
    { field: 'companyId', hide: true },
    { field: 'exceptionalSurveyId', hide: true },
    { field: 'mappedServiceLineId', hide: true },
    { headerName: 'User Name', field: 'userName', width: 280, resizable: true },
    { headerName: 'Show/Hide', field: 'isExceptionalUser', cellRenderer: (p: any) => this.showExceptionalUserRenderer(p), resizable: true }
  ];

  generalDocumentColumnDefs: ColDef[] = [
    { field: 'surveyId', hide: true },
    { field: 'serviceLineId', hide: true },
    { field: 'documentId', hide: true },
    { headerName: 'Document Name', field: 'documentName', width: 500, resizable: true },
    { headerName: 'File Name', field: 'fileName', width: 350, resizable: true },
    { headerName: 'Download', width: 100, cellRenderer: (p: any) => this.documentDownLoad(p), resizable: true },
    { field: 'value', hide: true },
    { field: 'uploadedBy', hide: true },
    { headerName: 'Delete', width: 120, cellRenderer: (p: any) => this.documentDelete(p), resizable: true }
  ];

  languageMappingColumnDefs: ColDef[] = [
    { field: 'mappingId', hide: true },
    { headerName: 'Survey Name', field: 'surveyName', width: 100, resizable: true },
    { headerName: 'Service Line Name', field: 'serviceLineName', width: 150, resizable: true },
    { headerName: 'Company Name', field: 'companyName', width: 100, resizable: true },
    { headerName: 'Language Name', field: 'languageName', width: 100, resizable: true },
    { headerName: 'Delete', cellRenderer: (p: any) => this.deleteLanguageImageRenderer(p), width: 100, resizable: true },
    { field: 'surveyId', hide: true },
    { field: 'serviceLineId', hide: true },
    { field: 'companyId', hide: true }
  ];

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    protected http: HttpClient,
    private EncrDecr: EncrDecrService,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public modalService: NgbModal,
    private manageServiceLineService: ManageServiceLineService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(http, oauth);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.serviceLineId = params['serviceLineId'];
      this.serviceLineName = params['serviceLineName'];
    });

    this.initForms();
    this.loadLanguageList();
    this.loadMappedSurveys();
    this.loadMappedServiceProviders();
    this.checkIsConsip();
  }

  // ── Form init ──────────────────────────────────────────────────────────────
  private initForms(): void {
    this.surveyForm = this.fb.group({});
    this.serviceProviderForm = this.fb.group({});

    this.copySurveyForm = this.fb.group({
      surveyName: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      sourceSurveyId: [0],
      serviceLineId: [0],
      isIncludeResponses: [false]
    });

    this.surveyScheduleForm = this.fb.group({ startDate: [''], endDate: [''] });

    this.respendentForm = this.fb.group({
      respondentId: new FormControl('', Validators.required)
    });

    this.exceptionalUserForm = this.fb.group({
      surveyId: new FormControl(null, Validators.required)
    });

    this.exceptionalFormatForm = this.fb.group({
      formatsurveyId: new FormControl(null, Validators.required)
    });

    this.usersDownloadForm = this.fb.group({
      usersmappedsurveyId: new FormControl(null, Validators.required)
    });

    this.isTemplateSurveyForm = this.fb.group({
      providersurveyId: [null],
      clientsurveyId: [null],
      isTemplateSurvey: [false],
      isProviderSurvey: [false],
      showDownloadReport: [false]
    });

    this.surveyProviderLanguageForm = this.fb.group({
      mappingId: [0],
      surveyId: [0],
      serviceLineId: [0],
      companyId: [''],
      languageId: ['']
    });

    this.exceptionalAnswersUpload = this.fb.group({
      answersuploadsurveyId: new FormControl(null, Validators.required),
      answersuploaduserId: new FormControl(null, Validators.required),
      statusId: new FormControl(null, Validators.required),
      file: new FormControl('', Validators.required),
      answerslist: [[]],
      serviceLineId: [-1],
      companyId: [-1]
    });

    this.uploadSurveyForm = this.fb.group({
      documentname: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      file: new FormControl('', Validators.required)
    });

    this.emailConfigurationForm = this.fb.group({
      email: new FormControl('', [Validators.email, Validators.required, this.noWhitespaceValidator]),
      emailPassword: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      serviceLineId: [this.serviceLineId]
    });
  }

  // ── Load data ──────────────────────────────────────────────────────────────
  loadMappedSurveys(): void {
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.getMappedSurveyList(this.serviceLineId, companyId).subscribe({
      next: (result) => this.serviceLineSurveyMapList = result,
      error: (err) => console.error(err)
    });
  }

  loadMappedServiceProviders(): void {
    this.manageServiceLineService.getMappedServiceProviderList(this.serviceLineId).subscribe({
      next: (result) => {
        this.serviceLineServiceProviderMapList = result;
        this.companyIds = result.map(r => r.companyId);
      },
      error: (err) => console.error(err)
    });
  }

  loadLanguageList(): void {
    this.manageServiceLineService.getLanguageList().subscribe({
      next: (data) => this.languageList = data,
      error: (err) => console.error(err)
    });
  }

  checkIsConsip(): void {
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.isConsipServiceLine(this.serviceLineId, workspaceId, companyId).subscribe({
      next: (result) => this.isConsip = result,
      error: (err) => console.error(err)
    });
  }

  // ── Modal openers ──────────────────────────────────────────────────────────
  openAddSurveyModal(): void {
    this.mapSurvey = [];
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.getUnMappedSurveyList(this.serviceLineId, workspaceId, companyId).subscribe({
      next: (result) => this.serviceLineSurveyUnMapList = result,
      error: (err) => console.error(err)
    });
    this.modalRef = this.modalService.open(this.mapSurveyModal, { backdrop: 'static', size: 'lg' });
  }

  openAddProviderModal(): void {
    this.mapServiceProvider = [];
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.manageServiceLineService.getUnMappedServiceProviderList(this.serviceLineId, workspaceId).subscribe({
      next: (result) => this.serviceLineServiceProviderUnMapList = result,
      error: (err) => console.error(err)
    });
    this.modalRef = this.modalService.open(this.mapProviderModal, { backdrop: 'static', size: 'lg' });
  }

  openEmailDetailsModal(): void {
    this.manageServiceLineService.getEmailDetails(this.serviceLineId).subscribe({
      next: (result) => {
        this.emailConfigurationForm.patchValue({
          email: result.email,
          emailPassword: result.emailPassword,
          serviceLineId: result.servicelineId
        });
        this.modalRef = this.modalService.open(this.emailSettingModal, { backdrop: 'static' });
      },
      error: (err) => console.error(err)
    });
  }

  // ── Navigation ─────────────────────────────────────────────────────────────
  backUrl(): void {
    this.router.navigate(['serviceline']);
  }

  navigateToConsipConfig(): void {
    this.router.navigate(['consipDemographicConfiguration', {
      serviceLineId: this.serviceLineId,
      serviceLineName: this.serviceLineName
    }]);
  }

  // ── Survey map / unmap ─────────────────────────────────────────────────────
  mapSurveyList(): void {
    const concatenated = this.mapSurvey.join(',');
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.mapSurveyToServiceLine(this.serviceLineId, concatenated, companyId).subscribe({
      next: (result) => { this.serviceLineSurveyMapList = result; this.mapSurvey = []; },
      error: (err) => console.error(err)
    });
  }

  mapServiceProviderList(): void {
    const concatenated = this.mapServiceProvider.join(',');
    this.manageServiceLineService.mapServiceProviderToServiceLine(this.serviceLineId, concatenated).subscribe({
      next: (result) => { this.serviceLineServiceProviderMapList = result; this.mapServiceProvider = []; },
      error: (err) => console.error(err)
    });
  }

  deleteSurvey(): void {
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.deleteSurveyServiceLine(this.serviceLineDeleteId, this.surveyDeleteId, companyId).subscribe({
      next: (result) => {
        this.serviceLineSurveyMapList = result.mappedSurveyList ?? [];
        this.successOrFailureMessage = result.messageInfo ?? '';
        this.messageTimeout();
      },
      error: (err) => console.error(err)
    });
  }

  deleteServiceProvider(): void {
    this.manageServiceLineService.deleteCompanyServiceLine(this.serviceLineDeleteId, this.companyDeleteId).subscribe({
      next: (result) => {
        this.serviceLineServiceProviderMapList = result.mappedServiceProviderList ?? [];
        this.successOrFailureMessage = result.messageInfo ?? '';
        this.messageTimeout();
      },
      error: (err) => console.error(err)
    });
  }

  // ── Schedule ───────────────────────────────────────────────────────────────
  updateDateRange(event: (Date | undefined)[] | undefined): void {
    if (event && Array.isArray(event) && event.length > 0 && event[0] && event[1]) {
      this.dateRangePickerModel = [event[0], event[1]];
      this.surveyScheduleForm.patchValue({
        startDate: event[0].toISOString().substring(0, 10),
        endDate: event[1].toISOString().substring(0, 10)
      });
    } else {
      this.dateRangePickerModel = [];
      this.surveyScheduleForm.patchValue({
        startDate: '',
        endDate: ''
      });
    }
  }

  saveSurveySchedule(): void {
    const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
    this.manageServiceLineService.saveSurveySchedule(this.surveyScheduleForm.value, companyId).subscribe({
      next: (result) => { this.serviceLineSurveyMapList = result; this.surveyScheduleForm.reset(); },
      error: (err) => console.error(err)
    });
  }

  // ── Copy survey ────────────────────────────────────────────────────────────
  copySurvey(): void {
    this.manageServiceLineService.copySurvey(this.copySurveyForm.value).subscribe({
      next: (result) => { this.serviceLineSurveyMapList = result; this.copySurveyForm.reset(); },
      error: (err) => console.error(err)
    });
  }

  // ── Template survey ────────────────────────────────────────────────────────
  saveTemplateSurvey(): void {
    const form = this.isTemplateSurveyForm.value;
    this.manageServiceLineService.saveTemplate({
      serviceLineId: this.currentFormatServiceLineId.toString(),
      providersurveyId: (form.providersurveyId ?? '').toString(),
      clientsurveyId: (form.clientsurveyId ?? '').toString(),
      isTemplate: form.isTemplateSurvey,
      currentSurveyId: this.currentSurveyId.toString(),
      isProviderSurvey: form.isProviderSurvey,
      showDownloadReport: form.showDownloadReport
    }).subscribe({
      next: (result) => {
        this.resetTemplateForm();
        this.successOrFailureMessage = result;
        this.messageTimeout();
        this.loadMappedSurveys();
      },
      error: (err) => console.error(err)
    });
  }

  resetTemplateForm(): void {
    this.isTemplateSurveyForm.reset();
    this.clientSurveyId = 0;
    this.providerSurveyId = 0;
    this.isTemplateSurveyChecked = false;
    this.isProviderSurveyChecked = false;
  }

  onIsProviderSurveyChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.isTemplateSurveyForm.patchValue({ isTemplateSurvey: false, providersurveyId: '', clientsurveyId: '' });
      this.isProviderSurveyChecked = true;
      this.isTemplateSurveyChecked = false;
    } else {
      this.isProviderSurveyChecked = false;
    }
  }

  onIsTemplateSurveyChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.isTemplateSurveyForm.patchValue({ isProviderSurvey: false });
      this.isProviderSurveyChecked = false;
      this.isTemplateSurveyChecked = true;
    } else {
      this.isTemplateSurveyChecked = false;
    }
  }

  // ── Respondent type ────────────────────────────────────────────────────────
  getRespondentId(): void {
    this.tempRespondentId = this.respendentForm.get('respondentId')?.value;
  }

  saveRespondent(): void {
    this.manageServiceLineService.saveRespondentType(this.tempServiceLineId, this.tempCompanyId, this.tempRespondentId).subscribe({
      next: () => {},
      error: (err) => console.error(err)
    });
  }

  // ── Exceptional users ──────────────────────────────────────────────────────
  loadQuestionByCompany(): void {
    this.companyUserList = [];
    const surveyId = this.exceptionalUserForm.get('surveyId')?.value;
    this.manageServiceLineService.getAllUsersByCompany(this.currentServiceLineId, this.currentCompanyId, surveyId).subscribe({
      next: (result) => this.companyUserList = result,
      error: (err) => console.error(err)
    });
  }

  // ── Format / download ──────────────────────────────────────────────────────
  downloadFormat(): void {
    const surveyId = this.exceptionalFormatForm.get('formatsurveyId')?.value;
    this.manageServiceLineService.formatDownload(this.currentFormatServiceLineId, surveyId, this.currentFormatCompanyId).subscribe({
      next: (result) => this.exportToExcel(result),
      error: (err) => console.error(err)
    });
  }

  userDownload(): void {
    const surveyId = this.usersDownloadForm.get('usersmappedsurveyId')?.value;
    this.manageServiceLineService.userDownload(this.companyIds, surveyId, this.serviceLineId).subscribe({
      next: (blob) => saveAs(blob as any, 'Users.xlsx'),
      error: (err) => console.error(err)
    });
  }

  // ── Upload answers ─────────────────────────────────────────────────────────
  answersUpload(): void {
    this.exceptionalAnswersUpload.patchValue({
      answersuploadsurveyId: this.currentUploadSurveyId,
      answersuploaduserId: this.currentUploadUserId,
      statusId: this.currentUploadStatusId,
      serviceLineId: this.currentUploadServiceLineId,
      companyId: this.currentUploadCompanyId
    });
    this.manageServiceLineService.uploadAnswers(this.exceptionalAnswersUpload.value).subscribe({
      next: (result) => {
        this.file = null;
        this.fileName = 'No File Chosen';
        this.exceptionalAnswersUpload.reset();
        this.showMessage(result === 'Success'
          ? 'Survey answers has been uploaded successfully into the tool.'
          : 'Error while importing survey answers.');
      },
      error: () => {
        this.exceptionalAnswersUpload.reset();
        this.file = null;
        this.fileName = 'No File Chosen';
        this.showMessage('Error while importing survey answers.');
      }
    });
  }

  loadStatus(): void {
    this.manageServiceLineService.getAllStatus().subscribe({
      next: (result) => this.statusList = result,
      error: (err) => console.error(err)
    });
  }

  // ── Document ───────────────────────────────────────────────────────────────
  selectFile(event: Event, form: FormGroup): void {
    const files = (event.target as HTMLInputElement).files;
    this.isFileInvalid = !files;
    if (files) this.selectedFiles = files;
  }

  uploadDocument(form: FormGroup): void {
    if (!this.selectedFiles) return;
    const file = this.selectedFiles.item(0)!;
    if (file.size / 1e6 >= 20) {
      this.successOrFailureMessage = 'File size cannot be greater than 20MB.';
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');

    this.http.post(
      `${this.manageServiceLineService.myAppUrl}/ManageServiceLine/UploadDocument`,
      formData,
      {
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        params: {
          serviceLineId: this.serviceLineId,
          userId,
          documentName: form.controls['documentname'].value,
          surveyId: this.surveyId,
          fileName: file.name
        }
      }
    ).subscribe({
      next: () => {
        form.controls['documentname'].reset();
        form.controls['file'].reset();
        this.selectedFiles = null;
        this.successOrFailureMessage = 'Document has been uploaded successfully.';
        this.messageTimeout();
      },
      error: (err) => console.error(err)
    });
  }

  // ── Language settings ──────────────────────────────────────────────────────
  saveSurveyProviderLanguage(): void {
    if (this.surveyProviderLanguageForm.invalid) return;
    this.manageServiceLineService.saveSurveyProviderLanguage(this.surveyProviderLanguageForm.value).subscribe({
      next: () => {
        this.surveyProviderLanguageForm.patchValue({ companyId: '', languageId: '' });
        this.loadSurveyServiceLineLanguageList(this.surveyProviderLanguageForm.value.surveyId);
      },
      error: (err) => console.error(err)
    });
  }

  loadSurveyServiceLineLanguageList(surveyId: number): void {
    this.manageServiceLineService.getSurveyServiceLineLanguageMappedList(surveyId, this.serviceLineId).subscribe({
      next: (result) => this.surveyServiceLineLanguageMappedList = result,
      error: (err) => console.error(err)
    });
  }

  deleteMapping(): void {
    this.manageServiceLineService.deleteSurveyCompanyLanguage(this.delSurveyId, this.serviceLineId, this.deleteMappingId).subscribe({
      next: (result) => {
        this.surveyServiceLineLanguageMappedList = result;
        this.successOrFailureMessage = 'Deleted data successfully.';
        this.messageTimeout();
      },
      error: () => {
        this.successOrFailureMessage = 'Error occurred while trying to delete the specified mapping. Please try again.';
      }
    });
  }

  // ── Email config ───────────────────────────────────────────────────────────
  saveEmailConfiguration(): void {
    this.manageServiceLineService.saveEmailConfiguration(this.emailConfigurationForm.value).subscribe({
      next: () => this.emailConfigurationForm.reset(),
      error: (err) => console.error(err)
    });
  }

  // ── Excel export (Kendo — same as user/company pattern) ────────────────────
  exportToExcel(params: any[]): void {
    if (!params?.length) return;
    const columns = Object.keys(params[0]);

    // Header row
    const headerRow = {
      cells: columns.map((col: string) => ({
        value: col,
        bold: true,
        background: '#FFFF00',
        borderBottom: { size: 1, color: '#000000' },
        borderTop: { size: 1, color: '#000000' },
        borderLeft: { size: 1, color: '#000000' },
        borderRight: { size: 1, color: '#000000' }
      }))
    };

    // Data rows
    const dataRows = params.map((item: any) => ({
      cells: columns.map((col: string) => ({ value: item[col] ?? '' }))
    }));

    const workbook = new Workbook({
      sheets: [{
        name: 'UploadFormat',
        rows: [headerRow, ...dataRows],
        columns: columns.map((col: string) => ({ width: Math.max(col.length, 15) * 7 }))
      }]
    });

    workbook.toDataURL().then((dataURL: string) => {
      saveAs(dataURL, `UploadFormat_${this.currentFormatCompanyName}.xlsx`);
    });
  }

  // ── File import (XLSX answers) ─────────────────────────────────────────────
  incomingFile(event: Event): void {
    const files = (event.target as HTMLInputElement).files;
    if (!files?.length) return;
    this.file = files[0];
    this.fileName = this.file.name;
    this.importAnswers();
  }

  importAnswers(): void {
    if (!this.file) return;
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const data = new Uint8Array(fileReader.result as ArrayBuffer);
      const arr = Array.from(data).map(b => String.fromCharCode(b));
      const workbook = XLSX.read(arr.join(''), { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const mainSheet: any[] = XLSX.utils.sheet_to_json(sheet, { raw: true });
      this.exceptionalAnswersUpload.patchValue({ answerslist: mainSheet });
    };
    fileReader.readAsArrayBuffer(this.file);
  }

  // ── Cell renderers (Renderer2 — same as user/company pattern) ─────────────
  actionRenderer(params: any): HTMLElement {
    const main = this.renderer.createElement('div');

    const addIcon = (icon: string, title: string, clickFn: () => void, modalTarget?: string) => {
      const anchor = this.renderer.createElement('a');
      const i = this.renderer.createElement('i');
      i.setAttribute('class', `fa ${icon} p-2`);
      i.setAttribute('title', title);
      if (modalTarget) {
        anchor.setAttribute('href', `#${modalTarget}`);
        anchor.setAttribute('data-toggle', 'modal');
      }
      this.renderer.appendChild(anchor, i);
      this.renderer.appendChild(main, anchor);
      this.renderer.listen(anchor, 'click', clickFn);
    };

    // Copy
    addIcon('fa-clone', 'Copy', () => {
      this.currentSelectedSurveyName = params.data.surveyName;
      this.copySurveyForm.patchValue({
        sourceSurveyId: params.data.surveyId,
        serviceLineId: this.serviceLineId,
        surveyName: 'Copy of ' + params.data.surveyName,
        isIncludeResponses: 0
      });
      this.modalRef = this.modalService.open(this.copySurveyModal, { backdrop: 'static' });
    });

    // Schedule
    addIcon('fa-calendar', 'Schedule', () => {
      this.currentSelectedSurveyName = params.data.surveyName;
      this.manageServiceLineService.editSurveySchedule(params.data.scheduleId, params.data.surveyId, params.data.serviceLineId).subscribe({
        next: (response) => {
          this.surveyScheduleForm = this.fb.group({
            startDate: [new Date(response.startDate).toISOString().slice(0, 10)],
            endDate: [new Date(response.endDate).toISOString().slice(0, 10)],
            surveyId: [response.surveyId],
            serviceLineId: [response.serviceLineId],
            scheduleId: [response.scheduleId]
          });
          this.dateRangePickerModel = response.scheduleId > 0
            ? [new Date(response.startDate), new Date(response.endDate)]
            : [];
          this.modalRef = this.modalService.open(this.surveyScheduleModal, { backdrop: 'static' });
        },
        error: (err) => console.error(err)
      });
    });

    // Delete
    addIcon('fa-trash', 'Delete', () => {
      this.serviceLineDeleteId = params.data.serviceLineId;
      this.surveyDeleteId = params.data.surveyId;
      this.modalRef = this.modalService.open(this.deleteSurveyModal, { backdrop: 'static' });
    });

    // Upload document
    addIcon('fa-upload', 'Upload Documents', () => {
      this.surveyId = params.data.surveyId;
      this.serviceLineId = params.data.serviceLineId;
      this.manageServiceLineService.getDocumentList(params.data.surveyId, params.data.serviceLineId).subscribe({
        next: (result) => this.documentList = result,
        error: (err) => console.error(err)
      });
      this.modalRef = this.modalService.open(this.uploadDocumentModal, { backdrop: 'static', size: 'lg' });
    });

    // Template settings
    addIcon('fa-cog', 'Template Survey', () => {
      this.currentFormatServiceLineId = params.data.serviceLineId;
      this.currentSurveyId = params.data.surveyId;
      this.providerSurveyId = params.data.providerSurveyId;
      this.isTemplateSurveyChecked = params.data.isTemplateSurvey;
      this.clientSurveyId = params.data.clientSurveyId;
      this.isTemplateSurveyForm.patchValue({
        providersurveyId: params.data.providerSurveyId,
        clientsurveyId: params.data.clientSurveyId,
        isTemplateSurvey: params.data.isTemplateSurvey,
        isProviderSurvey: params.data.isProviderSurvey,
        showDownloadReport: params.data.showDownloadReport
      });
      this.modalRef = this.modalService.open(this.templateModal, { backdrop: 'static' });
    });

    // Language settings
    addIcon('fa-cogs', 'Survey Company Language Settings', () => {
      this.currentFormatServiceLineId = params.data.serviceLineId;
      this.currentSurveyId = params.data.surveyId;
      this.surveyProviderLanguageForm.patchValue({
        surveyId: params.data.surveyId,
        serviceLineId: params.data.serviceLineId
      });
      this.loadSurveyServiceLineLanguageList(params.data.surveyId);
      this.modalRef = this.modalService.open(this.surveyProviderLanguageModal, { backdrop: 'static' });
    });

    // Randomization
    addIcon('fa-random', 'Survey Randomization Bucket Settings', () => {
      this.router.navigate(['surveybucketsettings', {
        surveyId: params.data.surveyId,
        serviceLineId: params.data.serviceLineId,
        serviceLineName: this.serviceLineName
      }]);
    });

    return main;
  }

  showCheckBoxRenderer(params: any): HTMLElement {
    const el = this.renderer.createElement('input');
    el.setAttribute('type', 'checkbox');
    if (params.data.isShow) el.setAttribute('checked', 'true');
    this.renderer.listen(el, 'click', (event: Event) => {
      const companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? '');
      this.manageServiceLineService.updateSurveyMap(
        this.serviceLineId, params.data.surveyId, (event.target as HTMLInputElement).checked, companyId
      ).subscribe({
        next: (result) => { this.serviceLineSurveyMapList = result; this.unMapSurvey = []; },
        error: (err) => console.error(err)
      });
    });
    return el;
  }

  showExceptionalUserRenderer(params: any): HTMLElement {
    const el = this.renderer.createElement('input');
    el.setAttribute('type', 'checkbox');
    if (!params.data.isExceptionalUser) el.setAttribute('checked', '');
    this.renderer.listen(el, 'click', (event: Event) => {
      this.manageServiceLineService.updateExceptionalUser(
        params.data.mappedServiceLineId,
        params.data.companyId,
        params.data.exceptionalSurveyId,
        (event.target as HTMLInputElement).checked,
        params.data.userId
      ).subscribe({
        next: (result) => { this.companyUserList = result; },
        error: (err) => console.error(err)
      });
    });
    return el;
  }

  companyLinkRenderer(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-user-o');
    el.setAttribute('class', 'anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.companyUserList = [];
      this.exceptionalUserForm.patchValue({ surveyId: -1 });
      this.currentServiceLineId = params.data.serviceLineId;
      this.currentCompanyId = params.data.companyId;
      this.currentCompanyName = params.data.companyName;
      this.modalRef = this.modalService.open(this.exceptionalUserModal, { backdrop: 'static', size: 'md' });
    });
    return el;
  }

  getRespondents(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const text = this.renderer.createText(params.value);
    this.renderer.appendChild(el, text);
    this.renderer.setAttribute(el, 'href', 'javascript:void(0)');
    this.renderer.listen(el, 'click', () => {
      this.tempServiceLineId = params.data.serviceLineId;
      this.tempCompanyId = params.data.companyId;
      this.manageServiceLineService.getRespondents(params.data.serviceLineId, params.data.companyId).subscribe({
        next: (result) => {
          this.respondentsTypesList = result;
          this.respendentForm.patchValue({ respondentId: result.selectedrespondentId });
          this.modalRef = this.modalService.open(this.respondentModal, { backdrop: 'static' });
        },
        error: (err) => console.error(err)
      });
    });
    return el;
  }

  deleteServiceProviderCellRenderer(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.serviceLineDeleteId = params.data.serviceLineId;
      this.companyDeleteId = params.data.companyId;
      this.modalRef = this.modalService.open(this.deleteProviderModal, { backdrop: 'static' });
    });
    return el;
  }

  formatDownload(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-download');
    el.setAttribute('class', 'anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.exceptionalFormatForm.patchValue({ formatsurveyId: -1 });
      this.currentFormatServiceLineId = params.data.serviceLineId;
      this.currentFormatCompanyId = params.data.companyId;
      this.currentFormatCompanyName = params.data.companyName;
      this.modalRef = this.modalService.open(this.formatDownloadModal, { backdrop: 'static' });
    });
    return el;
  }

  uploadAnswers(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-upload');
    el.setAttribute('class', 'anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.exceptionalAnswersUpload.patchValue({ answersuploadsurveyId: -1, answersuploaduserId: -1 });
      this.currentUploadServiceLineId = params.data.serviceLineId;
      this.currentUploadCompanyId = params.data.companyId;
      this.currentUploadCompanyName = params.data.companyName;
      this.modalRef = this.modalService.open(this.answersUploadModal, { backdrop: 'static' });
    });
    return el;
  }

  documentDownLoad(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-download anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      window.open(`${this.manageServiceLineService.myAppUrl}/ManageServiceLine/DownLoadDocument?documentId=${params.data.documentId}`);
    });
    return el;
  }

  documentDelete(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.manageServiceLineService.deleteDocument(this.surveyId, params.data.documentId).subscribe({
        next: () => {
          this.successOrFailureMessage = 'Document deleted successfully.';
          this.messageTimeout();
        },
        error: (err) => console.error(err)
      });
    });
    return el;
  }

  deleteLanguageImageRenderer(params: any): HTMLElement {
    const el = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(el, icon);
    this.renderer.listen(el, 'click', () => {
      this.deleteMappingId = params.data.mappingId;
      this.delSurveyId = params.data.surveyId;
      this.modalRef = this.modalService.open(this.deleteLanguageMappingModal, { backdrop: 'static' });
    });
    return el;
  }

  // ── Row selection ──────────────────────────────────────────────────────────
  onRowSurveySelected(params: any): void {
    if (params.node.selected) {
      if (params.data.serviceLineSurveyMapId > 0) this.unMapSurvey.push(params.data.surveyId);
      else this.mapSurvey.push(params.data.surveyId);
    } else {
      if (params.data.serviceLineSurveyMapId > 0) {
        const idx = this.unMapSurvey.indexOf(params.data.surveyId);
        if (idx !== -1) this.unMapSurvey.splice(idx, 1);
      } else {
        const idx = this.mapSurvey.indexOf(params.data.surveyId);
        if (idx !== -1) this.mapSurvey.splice(idx, 1);
      }
    }
  }

  onRowServiceProviderSelected(params: any): void {
    if (params.node.selected) {
      this.mapServiceProvider.push(params.data.companyId);
    } else {
      const idx = this.mapServiceProvider.indexOf(params.data.companyId);
      if (idx !== -1) this.mapServiceProvider.splice(idx, 1);
    }
  }

  // ── Helpers ────────────────────────────────────────────────────────────────
  noWhitespaceValidator(control: FormControl): { [key: string]: boolean } | null {
    const isWhitespace = (control.value ?? '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  messageTimeout(): void {
    window.setTimeout(() => this.successOrFailureMessage = '', 3200);
  }

  showMessage(msg: string): void {
    this.successOrFailureMessage = msg;
    this.messageTimeout();
  }

  loadUserForUploadAnswers(): void {
    // Get the selected survey, service line, and company
    const surveyId = this.currentUploadSurveyId;
    const serviceLineId = this.currentUploadServiceLineId;
    const companyId = this.currentUploadCompanyId;

    // Only proceed if all IDs are set
    if (surveyId && serviceLineId && companyId) {
      this.manageServiceLineService.getAllUsersByCompany(serviceLineId, companyId, surveyId).subscribe({
        next: (result) => {
          this.companyUserList = result;
        },
        error: (err) => console.error(err)
      });
    }
  }

}
